import React from 'react';
import { Route, RouteProps, RouteComponentProps } from 'react-router-dom';

import Authenticated from './Authenticated';
import LoadingAuthentication from './LoadingAuthentication';

type PrivateRouteProps = RouteProps & {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/require-default-props
    loading?: React.ComponentType;
};

const PrivateRoute = ({
    component,
    loading: Loading,
    ...props
}: PrivateRouteProps): React.ReactElement => (
    <Route
        {...props}
        render={(routeProps: RouteComponentProps): React.ReactElement => (
            <>
                <Authenticated>
                    {component ? React.createElement(component, { ...routeProps, ...props }) : null}
                </Authenticated>
                <LoadingAuthentication>{Loading ? <Loading /> : null}</LoadingAuthentication>
            </>
        )}
    />
);

export default PrivateRoute;
